// Owner: S3. Opening the formula editor from anywhere (the object builder, field inspector,
// field type picker): `openFormulaEditor({ objectKey: 'companies', fieldKey: 'health_score' })`.
// The editor is also reachable by URL: /settings/objects/companies?formula=health_score
// (`?formula=new` creates a formula field).

import { openLayer } from '../../shell/overlays';

export const FORMULA_SEARCH_PARAM = 'formula';
export const NEW_FORMULA = 'new';

export type FormulaEditorTarget = {
  objectKey: string;
  /** Existing formula field; omit to create a new one. */
  fieldKey?: string | null;
  /** Suggested label and key for a new field (field type picker). */
  label?: string;
};

/** Open the formula editor layer (`formula`, src/overlays/formula-editor.tsx). */
export function openFormulaEditor(target: FormulaEditorTarget): void {
  openLayer('formula', target);
}

/** `health_score` from "Health score". */
export function keyFromLabel(label: string): string {
  const key = label
    .replace(/ß/g, 'ss')
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 63);
  return /^[a-z]/.test(key) ? key : key ? `f_${key}`.slice(0, 63) : '';
}
